<!-- eslint-disable camelcase -->
<template>
  <div ref="myChart" :style="{ height: chartHeight, width: chartWidth }" class="chart-area">
  </div>
</template>
<script>
/* eslint-disable indent */
import {
  formatNumUnit
} from './js/numberFormat'
import echarts from 'echarts'
// import * as echarts from '@/common/echarts/echarts.min.js'

function splitData (rawData, type = 'macd') {
  const categoryData = []
  const values = []
  const volumes = []
  let record = {} // 单条记录
  // macd
  if (type === 'macd') {
    const MACD = []
    const DEA = []
    const DIF = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      MACD.push([i, rawData[i][8], rawData[i][8] < 0 ? 1 : -1])
      DEA.push(rawData[i][9])
      DIF.push(rawData[i][10])
    }
    record = {
      categoryData: categoryData,
      values: values,
      MACD: MACD,
      DEA: DEA,
      DIF: DIF
    }
  } else if (type === 'kdj') {
    const K = []
    const D = []
    const J = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      volumes.push([i, rawData[i][5], rawData[i][1] > rawData[i][2] ? 1 : -1])
      K.push([i, rawData[i][8], rawData[i][8] < 0 ? 1 : -1])
      D.push(rawData[i][9])
      J.push(rawData[i][10])
    }
    record = {
      categoryData: categoryData,
      values: values,
      volumes: volumes,
      K,
      D,
      J
    }
  } else if (type === 'rsi') {
    const RSI6 = []
    const RSI12 = []
    const RSI24 = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      RSI6.push([i, rawData[i][8], rawData[i][8] < 0 ? 1 : -1])
      RSI12.push(rawData[i][9])
      RSI24.push(rawData[i][10])
    }
    record = {
      categoryData: categoryData,
      values: values,
      RSI6,
      RSI12,
      RSI24
    }
  } else if (type === 'boll') {
    const MID = []
    const UPPER = []
    const LOWER = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      volumes.push([i, rawData[i][5], rawData[i][1] > rawData[i][2] ? 1 : -1])
      MID.push(rawData[i][8])
      UPPER.push(rawData[i][9])
      LOWER.push(rawData[i][10])
    }
    record = {
      categoryData: categoryData,
      values,
      volumes,
      MID,
      UPPER,
      LOWER
    }
  } else if (type === 'ma') {
    const MA5 = []
    const MA10 = []
    const MA20 = []
    const MA60 = []
    const MA120 = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      volumes.push([i, rawData[i][5], rawData[i][1] > rawData[i][2] ? 1 : -1])
      MA5.push(rawData[i][8])
      MA10.push(rawData[i][9])
      MA20.push(rawData[i][10])
      MA60.push(rawData[i][11])
      MA120.push(rawData[i][12])
    }
    record = {
      categoryData: categoryData,
      values,
      volumes,
      MA5,
      MA10,
      MA20,
      MA60,
      MA120
    }
  } else if (type === 'bias') {
    const bias6 = []
    const bias12 = []
    const bias24 = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      bias6.push(rawData[i][8])
      bias12.push(rawData[i][9])
      bias24.push(rawData[i][10])
    }
    record = {
      categoryData: categoryData,
      values,
      bias_6: bias6,
      bias_12: bias12,
      bias_24: bias24
    }
  } else if (type === 'wr') {
    const wr6 = []
    const wr10 = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      wr6.push(rawData[i][8])
      wr10.push(rawData[i][9])
    }
    record = {
      categoryData: categoryData,
      values,
      wr_6: wr6,
      wr_10: wr10
    }
  } else if (type === 'psy') {
    const psy = []
    const psyma = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      psy.push(rawData[i][8])
      psyma.push(rawData[i][9])
    }
    record = {
      categoryData: categoryData,
      values,
      psy,
      psyma
    }
  } else if (type === 'dmi') {
    const dmiPdi = []
    const dmiMdi = []
    const dmiAdx = []
    const dmiAdxr = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      values.push(rawData[i].slice(1, 14))
      dmiPdi.push(rawData[i][8])
      dmiMdi.push(rawData[i][9])
      dmiAdx.push(rawData[i][10])
      dmiAdxr.push(rawData[i][11])
    }
    record = {
      categoryData: categoryData,
      values,
      dmi_pdi: dmiPdi,
      dmi_mdi: dmiMdi,
      dmi_adx: dmiAdx,
      dmi_adxr: dmiAdxr
    }
  } else if (type === 'vol') {
    const vol1 = []
    const vol5 = []
    const vol10 = []
    for (let i = 0; i < rawData.length; i++) {
      categoryData.push([rawData[i].slice(0, 1)[0]])
      volumes.push([i, rawData[i][5], rawData[i][1] > rawData[i][2] ? 1 : -1])
      values.push(rawData[i].slice(1, 14))
      vol1.push(rawData[i][8])
      vol5.push(rawData[i][9])
      vol10.push(rawData[i][10])
    }
    record = {
      categoryData: categoryData,
      values,
      volumes,
      vol1,
      vol5,
      vol10
    }
  }
  return record
}

// -------------------------------计算曲线交点

// 求两条线段交点，a,b 为第一条线段的始末点，c,d 为第二条线段的始末点。x，y 为点的横纵坐标
// function segmentsIntr ({ a, b, c, d } = {}) {
//   var denominator = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y)
//   var x = ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) +
//     (b.y - a.y) * (d.x - c.x) * a.x -
//     (d.y - c.y) * (b.x - a.x) * c.x) / denominator
//   var y = -((b.y - a.y) * (d.y - c.y) * (c.x - a.x) +
//     (b.x - a.x) * (d.y - c.y) * a.y -
//     (d.x - c.x) * (b.y - a.y) * c.y) / denominator
//   return [x, y]
// }

// 获取tooltip的dot,radius 为圆点半径，color 为圆点颜色
// function getTipDot ({
//   radius = 5,
//   color = 'red'
// } = {}) {
//   return `<span style='width:${radius * 2}px;height:${radius * 2}px;display:inline-block;border-radius: ${radius}px;background:${color};margin:0px 3px;'></span>`
// }

// 判断两条线段是否有交点, a1、b1 为两条线在 x1 处的值；a2、b2 为两条线在 x2 处的值；
// 只要不是一条线段的两个点都高于另一个点就会有交点；
// function ifHaveIntersectionPoint (a1, b1, a2, b2) {
//   return (+a1 > +b1) !== (+a2 > +b2)
// }

// 是否执行后续的计算 ？ 不是最后一个点，且有交点时
// function ifCalculatePoint (idx, lth, [a1, b1, a2, b2] = []) {
//   return idx !== (lth - 1) && ifHaveIntersectionPoint(a1, b1, a2, b2)
// }

// 获取两线所有交点
// function getIntersectionPoint ({
//   line1,
//   line2,
//   date
// } = {}) {
//   // 交点数组
//   var intersectionPointList = []
//   date.map((seg, idx) => {
//     // 分别是两条线在相邻两处的数值，用于通过比较大小，来确定此段内是否有交点
//     var valueGroup = [line1[idx], line2[idx], line1[idx + 1], line2[idx + 1]]
//     if (ifCalculatePoint(idx, date.length, valueGroup)) {
//       var dotGroup = {
//         a: {
//           x: idx,
//           y: line1[idx]
//         },
//         b: {
//           x: idx + 1,
//           y: line1[idx + 1]
//         },
//         c: {
//           x: idx,
//           y: line2[idx]
//         },
//         d: {
//           x: idx + 1,
//           y: line2[idx + 1]
//         }
//       }
//       // 计算交点的位置
//       var intersectionPoint = segmentsIntr(dotGroup)
//       // 给每个数据拼接第三个值，代表是上升还是下降
//       intersectionPoint = [].concat(intersectionPoint, +line1[idx + 1] > +line2[idx + 1])
//       intersectionPointList.push(intersectionPoint)
//     }
//   })
//   return intersectionPointList
// }
// 计算移动平均线
function calculateMA (dayCount, data, predata) {
  var result = []
  // 拼接平移平均线
  const sumdata = JSON.parse(JSON.stringify(data))
  const dates = predata.map(item => {
    return item.date
  })
  const values = predata.map(item => {
    return item.values
  })
  sumdata.categoryData = dates.concat(sumdata.categoryData)
  sumdata.values = values.concat(sumdata.values)
  // 拼接平移平均线
  for (var i = 0, len = sumdata.categoryData.length; i < len; i++) {
    if (i < dayCount - 1) {
      result.push('-')
      continue
    }
    var sum = 0
    for (var j = 0; j < dayCount; j++) {
      sum += Number(sumdata.values[i - j][1])
    }
    // console.log((sum / dayCount).toFixed(2) ,sum)
    result.push((sum / dayCount).toFixed(2))
  }
  return result.slice(predata.length)
}
const upColor = '#ec0000'
const downColor = '#00da3c'
// ma  颜色
const ma5Color = '#39afe6'
const ma10Color = '#da6ee8'
const ma20Color = '#ffab42'
const MA60Color = '#00940b'
const MA120Color = '#FF7786'

export default {
  name: 'ChartK',
  props: {
    // 指标 1:成交量 2.MACD 3.KDJ
    currentIndex: {
      type: Number,
      default: 1
    },
    // 折线数据 时间 开盘价 收盘价 最低值 最高值 总量
    dataList: {
      type: Array,
      default: () => []
    },
    // 小数位数
    digit: {
      type: Number,
      default: () => 2
    },
    // 当前特征线
    curline: {
      type: String,
      default: ''
    },
    // 当前特征线
    range: {
      type: Number,
      default: 70
    },
    // 前置横坐标，用于历史回放
    xaxis: {
      type: Array,
      default: () => []
    },
    // 买入&&卖出标识数据
    markData: {
      type: Array,
      default: () => []
    },
    predata: { // 预设数据用于计算MA60
      type: Array,
      default: () => []
    },
    // 刷新图表
    isfresh: {
      type: Boolean,
      default: false
    },
    // 指标类型
    type: {
      type: String,
      default: 'macd'
    },
    // 是否作为聊天窗里的图表块
    isCard: {
      type: Boolean,
      default: false
    }
  },
  data () {
    this.myChart = null
    return {
      dataListTemp: [], // 备份dataList
      start: 0,
      end: 0,
      dataZoomY: null, // 保存dataZoomY信息
      chartHeight: '500px',
      chartWidth: '500px'
    }
  },
  watch: {
    currentIndex (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.drawLine()
      }
    },

    dataList: {
      handler (newValue, oldValue) {
        this.drawLine()
      },
      deep: true
    },

    curline: {
      handler (n) {
        this.drawLine()
      }
    },

    markData: {
      handler (newValue, oldValue) {
        this.drawLine()
      },
      deep: true
    },

    isfresh: {
      handler (n) {
        n && this.handleResize()
      }
    }
  },
  mounted () {
    // window.addEventListener('resize', this.handleResize, false)
    this.init()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize, false)
  },
  methods: {
    toDecimal (v) {
      if (!v) {
        return '--'
      }
      return parseFloat(v).toFixed(2)
    },
    init () {
      // 基于准备好的dom，初始化echarts实例
      // this.myChart = echarts.init(document.getElementById('myChart'))
      this.$nextTick(() => {
        this.myChart = echarts.init(this.$refs.myChart)
        // this.myChart.getZr().on('click', this.handleEchartsClick)
        this.drawLine()
      })
    },

    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      // this.myChart = this.$echarts.init(this.$refs.myChart)
      // 备份datalist

      this.dataListTemp = JSON.parse(JSON.stringify(this.dataList))
      // 处理datalist数据
      const chartOption = this.getChartOption()
      // 绘制图表
      this.myChart.setOption(chartOption, true)
    },
    getChartOption () {
      const _this = this
      const data = splitData(this.dataList, this.type)
      // console.log('处理完的数据', data)
      this.$emit('getHoverData', this.dataList[this.dataList.length - 1])
      let MA5, MA10, MA20, MA60
      // eslint-disable-next-line no-unused-vars
      let MA120 = []
      if (this.type === 'ma') {
        MA5 = data.MA5
        MA10 = data.MA10
        MA20 = data.MA20
        MA60 = data.MA60
        MA120 = data.MA120
        // boll指标，把MA5-MA20三个线的值改成
      } else {
        MA5 = calculateMA(5, data, this.predata)
        MA10 = calculateMA(10, data, this.predata)
        MA20 = calculateMA(20, data, this.predata)
        MA60 = calculateMA(60, data, this.predata)
        MA120 = calculateMA(120, data, this.predata)
      }

      this.$emit('getma', 'MA5', MA5[MA5.length - 1])
      this.$emit('getma', 'MA10', MA10[MA10.length - 1])
      this.$emit('getma', 'MA20', MA20[MA20.length - 1])
      this.$emit('getma', 'MA60', MA60[MA60.length - 1])
      if (this.type === 'ma') {
        MA120 = data.MA120
        this.$emit('getma', 'MA60', MA60[MA60.length - 1])
      }
      let ln = this.dataList.length
      this.start = 0
      this.end = ln >= 70 ? 70 : this.end
      const option = {
        color: ['#7499E4', '#FF7786', '#339900', '#ffab42'],
        animation: false,
        legend: {
          show: false
        },
        grid: [{
          left: '0%',
          right: '0%',
          top: this.isCard ? '0%' : '6.25%',
          height: '36.63%'
        },
        {
          left: '0%',
          right: '0%',
          bottom: this.isCard ? '0%' : '14%',
          height: '25.1%'
        }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(38, 43, 81, 0.5)',

          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          axisPointer: {
            type: 'cross'
          },
          position: function (pos, params, el, elRect, size) {
            var obj = { top: 10 };
            obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          // position: [20, 40],
          extraCssText: 'text-align: left;z-index:9999999;',
          formatter: function (params) {
            _this.setHoverData(params)
            var str = ''
            let param = {}
            for (const i in params) {
              if (params[i].seriesName === 'k线') {
                param = params[i]
              }
              if (params[i].seriesName === 'MA5') {
                _this.$emit('getma', 'MA5', params[i].value)
              }
              if (params[i].seriesName === 'MA10') {
                _this.$emit('getma', 'MA10', params[i].value)
              }
              if (params[i].seriesName === 'MA20') {
                _this.$emit('getma', 'MA20', params[i].value)
              }
              if (params[i].seriesName === 'MA60') {
                _this.$emit('getma', 'MA60', params[i].value)
              }
              if (params[i].seriesName === 'MA120') {
                _this.$emit('getma', 'MA120', params[i].value)
              }
              if (params[i].seriesName === 'MID') {
                _this.$emit('getma', 'MID', params[i].value)
              }
              if (params[i].seriesName === 'UPPER') {
                _this.$emit('getma', 'UPPER', params[i].value)
              }
              if (params[i].seriesName === 'LOWER') {
                _this.$emit('getma', 'LOWER', params[i].value)
              }
            }
            if (param.data && param.data.length > 1) {
              str =
                '日期：' +
                param.axisValue +
                '<br/>' +
                '开盘：' +
                _this.toDecimal(param.data[1], _this.digit, true) +
                '<br/>' +
                '收盘：' +
                _this.toDecimal(param.data[2], _this.digit, true) +
                '<br/>' +
                '最低：' +
                _this.toDecimal(param.data[3], _this.digit, true) +
                '<br/>' +
                '最高：' +
                _this.toDecimal(param.data[4], _this.digit, true) +
                '<br/>' +
                '涨跌幅：' +
                (param.data[7] > 0 ? '+' + param.data[7] : param.data[7]) + '%'
              return str
            } else {
              return ''
            }
          }
          // confine: true // 限制在容器内显示
        },
        axisPointer: {
          link: {
            xAxisIndex: 'all'
          }, // 绑定两个图
          label: {
            backgroundColor: '#777'
          }
        },
        visualMap: {
          show: false,
          seriesIndex: 1,
          dimension: 2,
          pieces: [{
            value: 1,
            color: downColor
          }, {
            value: -1,
            color: upColor
          }]
        },
        xAxis: [{
          type: 'category',
          // interval: 1,
          splitNumber: 10,
          boundaryGap: ['20%', '20%'],
          axisLabel: {
            show: false,
            color: '#999'
          },
          // 轴线样式
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          // 坐标轴刻度
          // axisTick: {
          //   interval: 5
          // },
          data: data.categoryData
        }, {
          type: 'category',
          // interval: 1,
          // type: 'time',
          gridIndex: 1,

          // 轴线样式
          axisLine: {
            show: true,
            lineStyle: {
              color: '#666'
            }
          },
          // 坐标轴刻度
          axisTick: {
            show: true
          },
          // 坐标轴指示器
          axisPointer: {
            label: {
              show: true
            }
          },
          data: data.categoryData
        }],
        yAxis: [{
          type: 'value',
          gridIndex: 0,
          scale: true,
          splitNumber: 5,
          // 坐标轴刻度
          axisTick: {
            show: false
          },
          // 标签
          axisLabel: {
            interval: true,
            textStyle: {
              color: '#999'
            },
            formatter: function (value) {
              return _this.toDecimal(value, _this.digit, true)
            }
          },
          // 轴线样式
          axisLine: {
            show: false
          },
          // 坐标轴在 grid 区域中的分隔线
          splitLine: {
            lineStyle: {
              color: 'rgba(100,100,100,0.2)'
            }
          }
          // min:this.leftMin,
          // max:this.leftMax,
          // interval: this.leftInterval,
        },
        {
          type: 'value',
          gridIndex: 1,
          scale: true,
          // 坐标轴刻度
          axisTick: {
            show: false
          },
          // 标签
          axisLabel: {
            interval: true,
            textStyle: {
              color: '#999'
            },
            formatter: function (value) {
              return formatNumUnit(value)
            }
          },
          // 轴线样式
          axisLine: {
            show: false
          },
          // 坐标轴在 grid 区域中的分隔线
          splitLine: {
            show: false
          }
        }
        ],
        series: [{
          name: 'k线',
          type: 'candlestick',
          barMaxWidth: 20,
          itemStyle: {
            normal: {
              color: upColor,
              color0: downColor,
              borderColor: upColor,
              borderColor0: downColor
            }
          },
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: data.values,
          lineStyle: {
            width: 1
          },
          label: {
            normal: {
              show: false
            }
          }
        }],
        dataZoom: []
      }

      option.tooltip.axisPointer.type = 'cross'

      option.xAxis[1].axisPointer = {}
      option.xAxis[1].axisPointer.label = {
        backgroundColor: 'none',
        formatter: function () {
          return ``
        }
      }
      option.grid[0].height = '55.63%'
      option.dataZoom = [{
        id: 'dataZoomX',
        type: 'inside',
        xAxisIndex: [0, 1],
        minValueSpan: 50,
        maxValueSpan: 80,
        height: 50
      },
      {
        id: 'dataZoomY',
        show: !this.isCard,
        xAxisIndex: [0, 1],
        type: 'slider',
        realtime: true,
        top: '93%',
        startValue: this.start,
        endValue: this.end
      }
      ]
      if (this.currentIndex === 1) {
        this.getLabelSeries(this.type, option, data)
      }
      if (this.markData.length) {
        console.log('传进来的标记数据 ======>', this.markData)
        option.series[1] = {
          ...option.series[1],
          markPoint: {
            label: {
              normal: {
                color: '#000',
                fontWeight: 'bold',
                fontSize: 12,
                padding: [0, 0, 0, 0],
                formatter: function (param) {
                  return ``
                }
              }
            },
            data: this.markData
          }
        }
      }
      if (this.type !== 'boll') {
        option.series.push({
          name: 'MA5',
          type: 'line',
          data: MA5,
          smooth: true,
          symbol: 'none', // 隐藏选中时有小圆点
          xAxisIndex: 0,
          yAxisIndex: 0,
          lineStyle: {
            normal: {
              opacity: 0.8,
              color: ma5Color
            }
          },
          itemStyle: {
            color: ma5Color
          }
        })
        option.series.push({
          name: 'MA10',
          type: 'line',
          data: MA10,
          smooth: true,
          symbol: 'none',
          xAxisIndex: 0,
          yAxisIndex: 0,
          lineStyle: { // 标线的样式
            normal: {
              opacity: 0.8,
              color: ma10Color
            }
          },
          itemStyle: {
            color: ma10Color
          }
        })
        option.series.push({
          name: 'MA20',
          type: 'line',
          data: MA20,
          smooth: true,
          xAxisIndex: 0,
          yAxisIndex: 0,
          symbol: 'none',
          lineStyle: {
            normal: {
              opacity: 0.8,
              color: ma20Color
            }
          },
          itemStyle: {
            normal: {
              color: ma20Color
            }
          }
        })
        option.series.push({
          name: 'MA60',
          type: 'line',
          data: MA60,
          smooth: true,
          symbol: 'none',
          xAxisIndex: 0,
          yAxisIndex: 0,
          lineStyle: {
            normal: {
              opacity: 0.8,
              color: MA60Color
            }
          },
          itemStyle: {
            color: MA60Color
          }
        })
      }

      return option
    },

    setHoverData (params) {
      const param = params.find(function (item) {
        return item.componentSubType === 'candlestick'
      })
      if (param !== undefined) {
        this.$emit('getHoverData', param.data)
      }
    },
    handleEchartsClick (params) {
      const pointInPixel = [params.offsetX, params.offsetY]
      if (this.myChart.containPixel('grid', pointInPixel)) {
        const pointInGrid = this.myChart.convertFromPixel({
          seriesIndex: 0
        }, pointInPixel)
        const xIndex = pointInGrid[0] // 索引
        const handleIndex = Number(xIndex)
        // const seriesObj = this.myChart.getOption() // 图表object对象
        this.$emit('click', handleIndex)
      }
    },

    handleResize () {
      this.myChart.resize()
    },
    getLabelSeries (type = 'macd', option, data) {
      switch (type) {
        case 'macd':
          option.series[1] = {
            name: 'MACD',
            type: 'bar',
            xAxisIndex: 1,
            barMaxWidth: 20,
            yAxisIndex: 1,
            data: data.MACD,
            showSymbol: false
          }
          option.series.push({
            name: 'DIF',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.DIF,
            showSymbol: false
          })
          option.series.push({
            name: 'DEA',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.DEA,
            showSymbol: false
          })
          // debugger
          // let chartData = {
          //   line1: data.DEA,
          //   line2: data.DIF,
          //   date: data.categoryData
          // }

          break;
        case 'kdj':
          option.series[1] = {
            name: 'D',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.D,
            showSymbol: false
          }
          option.series.push({
            name: 'J',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.J,
            showSymbol: false
          })
          option.series.push({
            name: 'K',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.K,
            showSymbol: false
          })
          break;
        case 'rsi':
          option.series[1] = {
            name: 'RSI6',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.RSI6,
            showSymbol: false
          }
          option.series.push({
            name: 'RSI12',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.RSI12,
            showSymbol: false
          })
          option.series.push({
            name: 'RSI24',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.RSI24,
            showSymbol: false
          })
          break;
        case 'boll':
          option.series[1] = {
            name: 'MID',
            type: 'line',
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: data.MID,
            showSymbol: false
          }
          option.series[2] = {
            name: 'UPPER',
            type: 'line',
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: data.UPPER,
            showSymbol: false
          }
          option.series[3] = {
            name: 'LOWER',
            type: 'line',
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: data.LOWER,
            showSymbol: false
          }
          option.series[4] = {
            name: '交易量',
            type: 'bar',
            barMaxWidth: 20,
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.volumes,
            itemStyle: {
              normal: {
                color: function (params) {
                  if (params.value[2] > 0) {
                    return '#00da3c'
                  } else {
                    return '#ec0000'
                  }
                }
              }
            }
          }
          break;
        case 'ma':
          option.series.push({
            name: 'MA120',
            type: 'line',
            data: data.MA120,
            smooth: true,
            symbol: 'none',
            xAxisIndex: 0,
            yAxisIndex: 0,
            lineStyle: {
              normal: {
                opacity: 0.8,
                width: 1,
                color: MA120Color
              }
            },
            itemStyle: {
              color: MA120Color
            }
          })
          option.series.push({
            name: '交易量',
            type: 'bar',
            barMaxWidth: 20,
            xAxisIndex: 1,
            yAxisIndex: 1,
            show: false,
            data: data.volumes,
            itemStyle: {
              normal: {
                color: function (params) {
                  if (params.value[2] > 0) {
                    return '#00da3c'
                  } else {
                    return '#ec0000'
                  }
                }
              }
            }
          })
          break;
        case 'bias':
          option.series[1] = {
            name: 'bias_6',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.bias_6,
            showSymbol: false
          }
          option.series.push({
            name: 'bias_12',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.bias_12,
            showSymbol: false
          })
          option.series.push({
            name: 'bias_24',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.bias_24,
            showSymbol: false
          })
          break;
        case 'wr':
          option.series[1] = {
            name: 'wr_6',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.wr_6,
            showSymbol: false
          }
          option.series.push({
            name: 'wr_10',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.wr_10,
            showSymbol: false
          })
          break;
        case 'psy':
          option.series[1] = {
            name: 'psy',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.psy,
            showSymbol: false
          }
          option.series.push({
            name: 'psyma',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.psyma,
            showSymbol: false
          })
          break;
        case 'dmi':
          option.series[1] = {
            name: 'dmi_pdi',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.dmi_pdi,
            showSymbol: false
          }
          option.series.push({
            name: 'dmi_mdi',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.dmi_mdi,
            showSymbol: false
          })
          option.series.push({
            name: 'dmi_adx',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.dmi_adx,
            showSymbol: false
          })
          option.series.push({
            name: 'dmi_adxr',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.dmi_adxr,
            showSymbol: false
          })
          break;
        case 'vol':
          option.series[1] = {
            name: '交易量',
            type: 'bar',
            barMaxWidth: 20,
            xAxisIndex: 1,
            yAxisIndex: 1,
            show: false,
            data: data.volumes
          }

          option.series.push({
            name: 'vol5',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.vol5,
            showSymbol: false
          })
          option.series.push({
            name: 'vol10',
            type: 'line',
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: data.vol10,
            showSymbol: false
          })
          break;
      }
    },
    /**
     * 补充空数据
     */
    getPreDates (date, ln) {
      const arr = []
      for (let i = 1; i < ln; i++) {
        // const d = new Date(new Date(date).setDate(new Date(date).getDate() + i)).toLocaleDateString()
        arr.push('')
      }
      return arr
    }

  },
  created () {

    // console.log('document.body.clientHeight', document.body.clientHeight)
  }

}
</script>
<style lang="less" scoped>
.chart-area {
  position: relative;
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/components/chart/chartk.vue